import { Col, Container, Row } from "@ui/wrapper";
import { HeadingType, ImageType, TextType } from "@utils/types";
import PropTypes from "prop-types";
import React from "react";
import { PageHeaderWrap, StyledDesc, StyledTitle } from "./style";

const PageHeader = ({ data }) => {
    return (
        <PageHeaderWrap>
            <Container>
                <Row textAlign="center">
                    <Col lg={8} mx="auto">
                        {data?.headings?.[0] && (
                            <StyledTitle as={data.headings[0]?.level}>
                                {data.headings[0]?.content}
                            </StyledTitle>
                        )}
                        {data?.texts?.[0] && (
                            <StyledDesc>{data.texts[0]?.content}</StyledDesc>
                        )}
                    </Col>
                </Row>
            </Container>
        </PageHeaderWrap>
    );
};

PageHeader.propTypes = {
    data: PropTypes.shape({
        headings: PropTypes.arrayOf(PropTypes.shape(HeadingType)),
        texts: PropTypes.arrayOf(PropTypes.shape(TextType)),
        images: PropTypes.arrayOf(PropTypes.shape(ImageType)),
    }),
};

export default PageHeader;
